// extracted by mini-css-extract-plugin
export default {"image":"M1-z","loaded":"N1-z"};